import { withLatestFrom } from "rxjs";
import { widgetStore$ } from "@/state/observable";
import { trackWidgetEvent } from "@/utils";
import { WidgetEvent$, type WidgetEvent } from "@/core";
import type { WidgetEventName } from "@/types";

export const startAnalyticsEffect = () => {
  const sub = WidgetEvent$.pipe(withLatestFrom(widgetStore$)).subscribe(
    ([event, store]) => {
      const st = store.state;

      const evNameMap: Record<WidgetEvent["type"], WidgetEventName> = {
        LOGIN_CLICK: "widget_login_click",
        RELOGIN_CLICK: "widget_relogin_click",
        LOGOUT_CLICK: "widget_logout_click",
        PROFILE_CLICK: "widget_profile_click",
        CHAT_OPEN: "widget_chat_open",
        CHAT_CONTINUE: "widget_chat_continue",
        CHAT_CLOSE: "widget_chat_close",
      };

      trackWidgetEvent({
        event_name: evNameMap[event.type] ?? "widget_unknown",
        client_id: st.clientId,
        env: (st as any).env,
      });
    },
  );

  return () => sub.unsubscribe();
};
